/**
 * Returns the standalone (controlpanel) origin for the current page by replacing the first
 * subdomain with `controlpanel`, so PSP hosts (`psp.<env>`) resolve to `controlpanel.<env>`.
 *
 * Same behaviour as `getStandaloneOrigin` in newer `@opengov/bnp-core` releases, which do not export
 * it from the 3.10.x line `reporting-app` is pinned to (see
 * docs/analysis/bnp-core-3.21.1-upgrade-requirements.md). Do not replace with the bnp-core import
 * until that pin is lifted.
 */
export const getStandaloneOrigin = (): string => {
  const { protocol, hostname, port } = window.location;
  const [, ...domainParts] = hostname.split('.');
  const standaloneHost = ['controlpanel', ...domainParts].join('.');
  const portSuffix = port ? `:${port}` : '';
  return `${protocol}//${standaloneHost}${portSuffix}`;
};
